<div class="message-template-display-container">


  <h4>{{messageTemplate?.subject}}</h4>
  <hr class="template-subject-divider" />
  <div class="message-template-content-container" [innerHTML]="messageTemplate?.template">
  </div>
</div>
